<ng-template [ngIf]="stats.countLocalAppliances" [ngIfThen]="appliancesCount"></ng-template>
<ng-template [ngIf]="!stats.countLocalAppliances" [ngIfThen]="appliancesSharedCount"></ng-template>
<ng-template [ngIf]="!stats" [ngIfThen]="emptyCount"></ng-template>

<ng-template #appliancesCount>
  <mat-chip-list>
    <mat-chip
      *ngIf="stats.countUpLocalAppliances || displayZeroCounts"
      class="chipStatusUp"
      [matTooltip]="'common.up' | t"
      [matTooltipDisabled]="displayLabels"
      (click)="onChipClick(APPLIANCE_STATUS.Up)"
    >
      <div class="upAppliancesText">
        <span *ngIf="displayLabels">{{ 'common.up' | t }}: </span>
        <span>{{ stats.countUpLocalAppliances | fsNumber }}</span>
      </div>
    </mat-chip>

    <mat-chip
      *ngIf="stats.countDownLocalAppliances || displayZeroCounts"
      class="chipDownStatus"
      [matTooltip]="'common.down' | t"
      [matTooltipDisabled]="displayLabels"
      (click)="onChipClick(APPLIANCE_STATUS.Down)"
    >
      <div class="downAppliancesText">
        <span *ngIf="displayLabels">{{ 'common.down' | t }}: </span>
        <span>{{ stats.countDownLocalAppliances | fsNumber }}</span>
      </div>
    </mat-chip>

    <mat-chip
      *ngIf="stats.countPendingLocalAppliances || displayZeroCounts"
      class="pendingAppliances"
      [matTooltip]="'common.pending' | t"
      [matTooltipDisabled]="displayLabels"
      (click)="onChipClick(APPLIANCE_STATUS.Pending)"
    >
      <div class="chipPendingStatus">
        <span *ngIf="displayLabels">{{ 'common.pending' | t }}: </span>
        <span>{{ stats.countPendingLocalAppliances | fsNumber }}</span>
      </div>
    </mat-chip>
  </mat-chip-list>
</ng-template>

<ng-template #appliancesSharedCount>
  <mat-chip-list>
    <mat-chip
      *ngIf="stats.countRecordingEnabledCameras || displayZeroCounts"
      class="chipStatusUp"
      [matTooltip]="'common.up' | t"
      [matTooltipDisabled]="displayLabels"
      (click)="onChipClick(APPLIANCE_STATUS.Up)"
    >
      <div class="upAppliancesText">
        <span *ngIf="displayLabels">{{ 'common.up' | t }}: </span>
        <span>{{ stats.countRecordingEnabledCameras | fsNumber }}</span>
      </div>
    </mat-chip>

    <mat-chip
      *ngIf="stats.countUnmangedCameras || displayZeroCounts"
      class="chipDownStatus"
      [matTooltip]="'common.down' | t"
      [matTooltipDisabled]="displayLabels"
      (click)="onChipClick(APPLIANCE_STATUS.Down)"
    >
      <div class="downAppliancesText">
        <span *ngIf="displayLabels">{{ 'common.down' | t }}: </span>
        <span>{{ stats.countUnmangedCameras | fsNumber }}</span>
      </div>
    </mat-chip>

    <mat-chip
      *ngIf="stats.countUnconfiguredCameras || displayZeroCounts"
      class="pendingAppliances"
      [matTooltip]="'common.pending' | t"
      [matTooltipDisabled]="displayLabels"
      (click)="onChipClick(APPLIANCE_STATUS.Pending)"
    >
      <div class="chipPendingStatus">
        <span *ngIf="displayLabels">{{ 'common.pending' | t }}: </span>
        <span>{{ stats.countUnconfiguredCameras | fsNumber }}</span>
      </div>
    </mat-chip>
  </mat-chip-list>
</ng-template>

<ng-template #emptyCount>
  <span class="empty">{{ 'common.noAppliancesFound' | t }}</span>
</ng-template>
